/** Push notification helper — wraps service worker subscription + Genesis push API. */
import { getPushPublicKey, pushSubscribe, pushUnsubscribe, getPushStatus } from "../../lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const arr = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i++) arr[i] = rawData.charCodeAt(i);
  return arr;
}

export const pushNotifications = {
  supported: () => typeof window !== "undefined" && "serviceWorker" in navigator && "PushManager" in window,

  permission: () => (typeof Notification !== "undefined" ? Notification.permission : "default"),

  async requestAndSubscribe() {
    if (!this.supported()) throw new Error("Push notifications not supported on this device");
    const perm = await Notification.requestPermission();
    if (perm !== "granted") throw new Error("Notifications permission denied");
    const reg = await navigator.serviceWorker.ready;
    const { public_key } = await getPushPublicKey();
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(public_key),
      });
    }
    await pushSubscribe(sub.toJSON(), navigator.userAgent || "");
    return sub;
  },

  async unsubscribe() {
    if (!this.supported()) return;
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      try { await pushUnsubscribe(sub.endpoint); } catch { /* */ }
      try { await sub.unsubscribe(); } catch { /* */ }
    }
  },

  async status() {
    if (!this.supported()) return { supported: false, permission: "unsupported", subscribed: false };
    try {
      const s = await getPushStatus();
      return { supported: true, permission: this.permission(), subscribed: !!s.subscribed };
    } catch {
      return { supported: true, permission: this.permission(), subscribed: false };
    }
  },
};
